export const BASE_BACKEND_URL = 'virtec-appello-back-dev.appelloproject.xyz';

export const API_URL = `https://${BASE_BACKEND_URL}/api/`;
